module.exports = __webpack_public_path__ + "img/Menu-15.93b5172b.png";